import { string } from "../types/string";
import { translateContent } from "utils/localisation";

export default function join(a, b) {
  return string(translateContent(a)) + string(translateContent(b));
}
